import React, { useEffect } from 'react';

import { track } from '@betterment/js-runtime';
import { Box, Icon } from '@betterment/samba-react';
import { Flex, HR, Heading, ListRowButton } from '@betterment/style-closet-react';

import { DirectDepositStepProps, PayCheckAmount } from './data';
import { useTitleDispatch } from './utils';

export interface Props {
  employerName: string;
  payCheckAmount: PayCheckAmount;
}

export const SelectPayCheckAmountType: React.FC<React.PropsWithChildren<DirectDepositStepProps>> = ({
  goToNextStep,
}) => {
  const setTitle = useTitleDispatch();
  useEffect(() => setTitle('Direct deposit form'), [setTitle]);
  return (
    <>
      <Flex justifyContent="left" mb="1" pb="8">
        <Heading variant="primary">How much of each paycheck do you want to deposit into Betterment Checking?</Heading>
      </Flex>
      <HR />
      <Box
        css={{
          background: 'white.100',
        }}
      >
        <ListRowButton
          variant="expanded"
          verticalAlign="top"
          leadingTitle="Entire paycheck"
          trailingIcon={<Icon name="CaretRight" size="small" />}
          onPress={() => {
            goToNextStep({
              payCheckAmount: { type: 'percentage', value: 100 },
              lastUserEvent: 'selectedEntirePayCheck',
            });
            track('ElementClicked', { name: 'EntirePaycheck', module: 'SetUpDirectDeposit' });
          }}
        />
      </Box>
      <HR />
      <Box
        css={{
          background: 'white.100',
        }}
      >
        <ListRowButton
          variant="expanded"
          verticalAlign="top"
          leadingTitle="Percentage"
          trailingIcon={<Icon name="CaretRight" size="small" />}
          onPress={() => {
            goToNextStep({ lastUserEvent: 'selectedPayCheckPercentage' });
            track('ElementClicked', { name: 'PercentofPaycheck', module: 'SetUpDirectDeposit' });
          }}
        />
      </Box>
      <HR />
      <Box
        css={{
          background: 'white.100',
        }}
      >
        <ListRowButton
          variant="expanded"
          verticalAlign="top"
          leadingTitle="Amount"
          trailingIcon={<Icon name="CaretRight" size="small" />}
          onPress={() => {
            goToNextStep({ lastUserEvent: 'selectedPayCheckDollarAmount' });
            track('ElementClicked', { name: 'AmountOfPaycheck', module: 'SetUpDirectDeposit' });
          }}
        />
      </Box>
      <HR />
    </>
  );
};
